import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import { toHttpParams, snakeCase, toCamelcase, createNamedApi, combineEffectsWithProviders } from '@essent/common';
import * as i1$1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';
import * as i1 from '@angular/common/http';

/**
 * @ignore
 */
const API = new InjectionToken('api-marketing');

class GetMarketingProfileService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/marketing/profile/v${this.apiVersion}`;
    }
    call$(payload) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase(payload));
        return this.httpClient.get(this.endpoint, { headers, params }).pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetMarketingProfileService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetMarketingProfileService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetMarketingProfileService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const getMarketingProfileApi = createNamedApi('[Marketing profile API] Get marketing profile', GetMarketingProfileService);

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getMarketingProfileApi);
class MarketingCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('MarketingCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: MarketingCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: MarketingCoreModule, deps: [{ token: MarketingCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: MarketingCoreModule, imports: [i1$1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: MarketingCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: MarketingCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: MarketingCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getMarketingProfileActions, getMarketingProfile, getMarketingProfileSuccess, getMarketingProfileError, getMarketingProfileClear } = getMarketingProfileApi;

var ContractType;
(function (ContractType) {
    ContractType["FIXED"] = "fixed";
    ContractType["DYNAMIC"] = "dynamic";
    ContractType["VARIABLE"] = "variable";
})(ContractType || (ContractType = {}));
var Score;
(function (Score) {
    Score["VERY_LOW"] = "very_low";
    Score["LOW"] = "low";
    Score["MEDIUM"] = "medium";
    Score["HIGH"] = "high";
})(Score || (Score = {}));
var CustomerPhase;
(function (CustomerPhase) {
    CustomerPhase["NEW_CUSTOMER"] = "new_customer";
    CustomerPhase["FIXED"] = "fixed";
    CustomerPhase["RENEWABLE"] = "renewable";
    CustomerPhase["VARIABLE"] = "variable";
    CustomerPhase["OTHER"] = "other";
})(CustomerPhase || (CustomerPhase = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { API, ContractType, CustomerPhase, MarketingCoreModule, Score, getMarketingProfile, getMarketingProfileActions, getMarketingProfileClear, getMarketingProfileError, getMarketingProfileSuccess };
